const Full = () => import( '@/container/Full.vue')

// dashboard components
const acsExecuteRoutes = () => import(/* webpackPrefetch: false */ '@/views/acs/AcsExecute.vue')
const acsParamDetailsRoutes = () => import(/* webpackPrefetch: false */ '@/views/acs/AcsParamDetails.vue')
export default {
  path: '/routers',
  component: Full,
  redirect: '/routers',
  beforeEnter(to, from, next) {
    if (localStorage.getItem('token')) {
      next()
    } else {
      next('/signin')
    }
  },
  children: [
    {
      path:"/acs/cpe_devices",
      component: acsExecuteRoutes,
      meta: {
        title: "Execute"
      }
    },
    {
      path: '/acs/parameterNames/:DeviceName',
      component: acsParamDetailsRoutes,
      meta: {
        title: "TR069 Config"
      }
    },
  ]
}
